<div class="hvac-loading-spinner"  [ngClass]="{'hvac-size-small': spinnerSize === 'small' }">
    <div class="hvac-spinner">
        <utc-svg class="hvac-spinner-icon" src="assets/icons/default.svg"></utc-svg>
    </div>
    <ng-content></ng-content>
</div>
